import mutationsTypes from '@/store/mutationTypes'
import axios from 'axios'
import api from '@/config/api'
import apiMock from '@/config/apiMock'
import store from '@/store/index'
import { commonUtil } from '@/util'
import getCsrfToken from '@/store/Csrf'
import requestCustomerEdit from './request/requestCustomerEdit'
import requestCustomerRegister from './request/requestCustomerRegister'
import { i18n } from '@/main.js'
import { countryUtil } from '@/util'

const Actions = {
  // CU01 顧客一覧取得
  getCustomersFromApi: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    return await axios
      // .get(apiMock.CUSTOMERS)
      .get(api.CUSTOMERS, { params: params })
      .then((response) => {
        const customerList = response.data.data.customerList
        // マスタ画面一覧ソート用の値を追加
        customerList.forEach((customer) => {
          // 顧客名
          const customerCategoryList = rootState.Common.customerCategoryList
          const customerCategory = customerCategoryList.find(
            (element) =>
              element.customerCategoryId === customer.customerCategoryId
          )
          customer.customerCategoryName = customerCategory
            ? customerCategory.name
            : '-'

          // 会社名 部署名
          const organizationName = customer.organizationName
          const sectionName = customer.sectionName
          customer.organizationAndSection =
            organizationName || sectionName
              ? organizationName + sectionName
              : '-'

          // 詳細情報
          const phoneNumber = customer.phoneNumber
            ? i18n.tc('common.common_tel') + ':' + customer.phoneNumber
            : ''
          const mailAddress = customer.mailAddress
            ? i18n.tc('common.input_email') + ':' + customer.mailAddress
            : ''
          const wechatId = customer.wechatId
            ? i18n.tc('common.input_we-chat-id') + ':' + customer.wechatId
            : ''
          const customerNote = customer.customerNote
            ? i18n.tc('common.input_remarks') + ':' + customer.customerNote
            : ''
          const url = customer.url || ''
          customer.details =
            phoneNumber + mailAddress + wechatId + customerNote + url || '-'

          // 請求書情報
          const billingOrganizationName = customer.billingOrganizationName || ''
          const billingName =
            customer.billingSectionName || customer.billingName
              ? customer.billingSectionName +
                customer.billingName +
                i18n.tc('sale.sale_mr')
              : ''
          const regionName = countryUtil.getRegionInfo(
            customer.billingAddressCountryId,
            customer.billingRegionId
          ).label
          const address = (regionName || '') + (customer.billingAddress1 || '')
          const address2 = customer.billingAddress2 || ''
          const billingPhoneNumber = customer.billingPhoneNumber
            ? i18n.tc('common.common_tel') + ':' + customer.billingPhoneNumber
            : ''
          customer.billingInfo =
            billingOrganizationName +
              billingName +
              address +
              address2 +
              billingPhoneNumber || '-'
          // 受取人情報のソート
          customer.recipients.sort((recipient1, recipient2) => {
            return recipient1.sortNumber - recipient2.sortNumber
          })
        })
        const path = mutationsTypes.CUSTOMER_SET_CUSTOMER_INFO_LIST
        commit(path, { customerList })

        const getData = getters.getCustomerListFromState
        // commonUtil.hasRegisteredUserInfo(response.data)
        const ret = commonUtil.afterApiSuccessProcess(response, getData)
        return ret
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // CU02 顧客登録
  registerCustomer: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()
    const req = requestCustomerRegister.request.createRequest(params)

    return await axios
      // .get(apiMock.CUSTOMER_REGISTER_EDIT)
      .post(api.CUSTOMER_REGISTER_EDIT, req)
      .then((response) => {
        return true
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // CU03 顧客編集
  editCustomer: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    try {
      const req = requestCustomerEdit.request.createRequest(params)

      return await axios
          // .get(apiMock.CUSTOMER_REGISTER_EDIT)
          .patch(`${api.CUSTOMER_REGISTER_EDIT}/${params.id}`, req)
          .then((response) => {
            return true
          })
          .catch((error) => {
            // commonErrorControl(error.response)
            commonUtil.afterApiFailProcess(error.response)
            return false
          })

    } catch(e) {
      const neShopIdError = {
        status: 400,
        data: {
          message: i18n.tc('common.common_unexpected-error'),
        }
      }
      commonUtil.afterApiFailProcess(neShopIdError)
      return false
    }
  },
  // CU04 顧客CSVアップロード
  fileUpload: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    file
  ) => {
    const instance = axios.create({
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    await getCsrfToken()
    return await instance
      // .get(apiMock.FILE_UPLOAD)
      .post(api.CUSTOMER_CSV_UPLOAD, file)
      .then((response) => {
        const ret = commonUtil.afterApiSuccessProcess(
          response,
          response.data.data
        )
        return ret
      })
      .catch((error) => {
        if (error.response.data.data && error.response.data.data.errorList) {
          const errors = []
          error.response.data.data.errorList.forEach((ele) => {
            for (const index in ele.errors) {
              ele.errors[index].flat().forEach((error) => {
                const errorMsg =
                  i18n.locale === 'cn'
                    ? `第${ele.lineNumber}行 ${error}`
                    : `${ele.lineNumber}行目 ${error}`
                errors.push(errorMsg)
              })
            }
          })

          alert(`${errors.join('\n')}`)
          return false
        }
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  }
}

export default Actions
